<template>
	<div>
		<Breadcrumbs main="container.resource" title="container.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div>
                <div class="row">
                    <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('container.activeContList') }}</h2>
                    <b-button v-show="process === 'info'" pill href="#addContainer" size="sm" @click="process = 'add' " class="bg-primary mb-4 mt-3 ml-3 ">
                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('container.add') }} </span>
                    </b-button>                    
                    <b-col lg="3" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>                                                                
                            <b-form-checkbox value="owner">{{ $t('matchTx.agent') }}</b-form-checkbox>
                            <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                            <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                            <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(edit)="row" >
                        <b-button pill size="sm" @click="actUpdate(row.item)" class="m-1">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.update') }}</span>
                        </b-button>
                    </template>
                    <template #cell(delete)="row" >
                        <b-button pill size="sm" @click="actDelete(row.item)" class="m-1">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                        </b-button>
                    </template>

                    <template #cell(contImage)="row" >
                        <b-button size="sm" @click="openModalImage(row.item, row.index, $event.target )" class="m-1">
                            {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
                        </b-button>
                    </template>
                    <!-- <template slot="bottom-row">
                        <td></td>
                        <b-button pill href="#addContainer" size="sm" @click="process = 'add' " class="bg-primary  ml-3 mt-3">
                            <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('container.add') }} </span>
                        </b-button>
                    </template> -->
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                    <!-- Info modal Container Image-->
                <b-modal id="contModal" :title="modalTitle" ok-only @hide="resetInfoModal">
                    <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModal"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <!-- <button @click="deleteImage(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button> -->
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                                    </div>
                                    <div v-if="imageUriModal.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModal.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </b-modal>
            </div>
            <div class="divider"> </div>
            <div v-show="process === 'add' " class="row ">
                <div id="addContainer" class="col-sm-6 gradient-wy">
                    <div class="d-flex flex-row justify-content-between mx-1">
                        <div class="row ml-3" v-b-hover="handleHover">
                            <h2 class="text-primary mt-3">{{ $t('container.add') }}</h2>
                            <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                            <span v-show="isHovered" class="text-danger">{{ $t('container.cancelReturn')  }} </span>
                        </div>
                        <div class="form-group mt-2">
                            <router-link to="/process/release">
                            <button class="btn btn-outline-primary btn-block" style="font-size:18px"  type="button">{{ $t('release.header') }}</button>                                        
                            </router-link>
                        </div>
                    </div>

                    <form class="theme-form">
                        <div class="row">
                            <div class="form-group col-sm-4"  v-b-popover.hover.top="$t('container.dummyMsg')" >
                                <label for="contNo" class="f-w-600 ml-3" style="font-size: 16px">{{ $t("container.contNo") }}</label>                                                 
                                <input  v-model="contNo" class="form-control" type="text" id="contNo" :placeholder="$t('container.contNoPh')" >
                            </div>                            
                            <div class="form-group col-sm-5 ml-3">
                                <label for="owner" class="f-w-600 ml-3" style="font-size: 16px;"  >{{ $t("container.owner") }}</label> 
                                <v-select label="owner"  style="font-size:16px;" v-model="owner" :options="agentList" :placeholder="$t('container.ownerPh')">                                        
                                </v-select>
                            </div>                                
                        </div>
                        <div class="row ml-3">
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-form-group class="f-w-600" style="font-size: 16px"  :label="$t('container.contSize')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contSize"
                                            :options="optionsContSize"
                                            :aria-describedby="ariaDescribedby"
                                            name="contSize-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="row">
                                <div class="col-sm-12 ml-5">
                                    <b-form-group class="f-w-600" style="font-size: 16px"  :label="$t('container.contType')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contType"
                                            :options="optionsContType"
                                            :aria-describedby="ariaDescribedby"
                                            name="contType-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="row">
                            <div class="col-sm-12 ml-5">
                                <b-form-group class="f-w-600" style="font-size: 16px" :label="$t('container.contGrade')" v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group
                                        v-model="contGrade"
                                        :options="optionsContGrade"
                                        :aria-describedby="ariaDescribedby"
                                        name="contGrade-options"
                                        size="lg"                                            
                                        plain
                                        stacked
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>                                  
                            </div>
                           
                        </div>
                        <h4 class="text-warning">{{ $t('container.optionalInfo') }}</h4>
                        <div class=" row ml-3">

                            <div class="form-group ml-5 ">
                                <label for="maxGross" class="col-form-label f-w-600" style="font-size: 16px">{{ $t("container.maxGross") }}</label>
                                <input v-model="maxGross" class="form-control" type="text" id="maxGross" :placeholder="$t('container.maxGrossPh')" >
                            </div>
                            <div class="form-group ml-5">
                                <label for="tare" class="col-form-label  f-w-600" style="font-size: 16px">{{ $t("container.tare") }}</label>
                                <input v-model="tare" class="form-control" type="text" id="tare" :placeholder="$t('container.tarePh')" >
                            </div> 
                            <div class="form-group ml-2">
                                <label for="detDate" class="col-form-label f-w-600" style="font-size: 16px">{{ $t("container.detDate") }}</label>
                                <datepicker input-class="datepicker-here form-control digits"  :disabled-dates="disabledDates"  :format="format" v-model="detDate" ></datepicker>
                            </div>                            
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" style="font-size:20px"  type="button" @click="handleSave">{{ $t('container.save') }}</button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6">
                    <div class="gradient-yg p-1" >
                        <div class="dashboard">
                          <div class="upload-section">
                            <input
                              type="file"
                              ref="fileInput"
                              accept="image/*"
                              multiple
                              @change="onFileSelect"
                              style="display: none"
                            >
                            <div class="d-flex flex-row justify-content-center">
                              <button @click="selectFiles" class="upload-btn" :disabled="images.length >= 6">
                                {{images.length < 6 ? $t('container.uploadImageFor6') : $t('container.uploadImageDone6') }}
                              </button>
                            </div>
                            <p v-if="images.length < 6" class="upload-6Img-message"> {{$t('approvedTrans.6ImagesReqrMsg')  }}</p>
                            <p v-if="uploading" class="upload-status">Uploading... {{ uploadProgress }}%</p>
                          </div>
                          <!-- Horizontal Scroll View for Images -->
                          <div class="image-scroll-container">
                            <div class="image-scroll" ref="scrollContainer">
                              <div
                                class="image-item"
                                v-for="(image, index) in images"
                                :key="image.id"
                              >
                                <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                <button @click="deleteImage(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button>
                                <span class="image-counter">{{ index + 1 }} of {{ images.length }}</span>
                              </div>
                              <div v-if="images.length === 0" class="no-images">
                                {{$t('approvedTrans.noImageYet') }}
                              </div>
                            </div>
                            <div class="scroll-controls" v-if="images.length > 1">
                              <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                              <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="process === 'update' " class="row">
                <div class="col-sm-6">
                    <div class="row ml-3" v-b-hover="handleHover">
                        <h3 class="text-primary mt-3">{{ $t('container.edit') }}</h3>
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcessAdd">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('container.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form">
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <label for="contNo" class="f-w-600 ml-3 text-primary" style="font-size: 16px">{{ $t("container.contNo") }}</label>                                                 
                                <input  v-model="contNo" class="form-control" type="text" id="contNo">
                            </div>                            
                            <div class="form-group col-sm-5 ml-3">
                                <label for="owner" class="f-w-600 ml-3 text-primary" style="font-size: 16px;"  >{{ $t("container.owner") }}</label> 
                                <v-select label="owner"  style="font-size:16px;" v-model="owner" :options="agentList" :placeholder="$t('container.ownerPh')">                                        
                                </v-select>
                            </div>                                
                        </div>
                        <div class="row ml-3">
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-form-group class="f-w-600 text-primary" style="font-size: 16px"  :label="$t('container.contSize')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contSize"
                                            :options="optionsContSize"
                                            :aria-describedby="ariaDescribedby"
                                            name="contSize-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="row">
                                <div class="col-sm-12 ml-5">
                                    <b-form-group class="f-w-600 text-primary" style="font-size: 16px"  :label="$t('container.contType')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contType"
                                            :options="optionsContType"
                                            :aria-describedby="ariaDescribedby"
                                            name="contType-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="ol-sm-12 ml-5">
                                <b-form-group class="f-w-600 text-primary" style="font-size: 16px" :label="$t('container.contGrade')" v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group
                                        v-model="contGrade"
                                        :options="optionsContGrade"
                                        :aria-describedby="ariaDescribedby"
                                        name="contGrade-options"
                                        size="lg"                                            
                                        plain
                                        stacked
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>                             
                        </div>
                        <h4 class="text-warning">{{ $t('container.completeInfo') }}</h4>
                        <div class=" row ml-3">
                            <div class="form-group ml-5 ">
                                <label for="maxGross" class="col-form-label f-w-600 text-primary" style="font-size: 16px">{{ $t("container.maxGross") }}</label>
                                <input v-model="maxGross" class="form-control" type="text" id="maxGross" :placeholder="$t('container.maxGrossPh')" >
                            </div>
                            <div class="form-group ml-5">
                                <label for="tare" class="col-form-label  f-w-600 text-primary" style="font-size: 16px">{{ $t("container.tare") }}</label>
                                <input v-model="tare" class="form-control" type="text" id="tare" :placeholder="$t('container.tarePh')" >
                            </div> 
                            <div class="form-group ml-5 mt-2">
                                <label for="detDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("container.detDate") }}</label>
                                <datepicker input-class="datepicker-here form-control digits"  :disabled-dates="disabledDates"  :format="format" v-model="detDate" ></datepicker>
                            </div>                            
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('container.update') }}</button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6">
                    <div class="gradient-yb p-1" >
                        <div class="dashboard">
                          <div class="upload-section">
                            <input
                              type="file"
                              ref="fileInputUpdate"
                              accept="image/*"
                              multiple
                              @change="onFileSelectUpdate"
                              style="display: none"
                            >
                            <div class="d-flex flex-row justify-content-center">
                              <button @click="selectFilesUpdate" class="upload-btn-update" :disabled="images.length >= 6">
                                {{images.length < 6 ? $t('container.uploadImageFor6') : $t('container.uploadImageDone6') }}
                              </button>
                            </div>
                            <p v-if="images.length < 6" class="upload-6Img-message"> {{$t('approvedTrans.6ImagesReqrMsg')  }}</p>
                            <p v-if="uploading" class="upload-status">Uploading... {{ uploadProgress }}%</p>
                          </div>
                          <!-- Horizontal Scroll View for Images -->
                          <div class="image-scroll-container">
                            <div class="image-scroll" ref="scrollContainer">
                              <div
                                class="image-item"
                                v-for="(image, index) in images"
                                :key="image.id"
                              >
                                <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                <button @click="deleteImageUpdate(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button>
                                <span class="image-counter">{{ index + 1 }} of {{ images.length }}</span>
                              </div>
                              <div v-if="images.length === 0" class="no-images">
                                {{$t('approvedTrans.noImageYet') }}
                              </div>
                            </div>
                          
                            <div class="scroll-controls" v-if="images.length > 1">
                              <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                              <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider"> </div>
            <div>
                <div class="row">
                    <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('container.usedContList') }}</h2>                  
                    <b-col lg="3" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input-used"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input-used"
                            v-model="filterUsed"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filterUsed" @click="filterUsed = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirectionUsed"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedbyUsed }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOnUsed"
                            :aria-describedby="ariaDescribedbyUsed"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>                                                                
                            <b-form-checkbox value="owner">{{ $t('matchTx.agent') }}</b-form-checkbox>
                            <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                            <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                            <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="secondary"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortByUsed"
                    :sort-desc.sync="sortDescUsed"
                    :sort-direction="sortDirectionUsed"
                    :filter="filterUsed"
                    :filter-included-fields="filterOnUsed"
                    :items="itemsUsed"
                    :fields="fieldsUsed"
                    :current-page="currentPageUsed"
                    :per-page="perPageUsed"
                    @filtered="onFilteredUsed"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(actEdit)="row" >
                        <b-button pill size="md" variant="primary" @click="actEditContNoUsed(row.item)" class="m-1">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.contNo') }}</span>
                        </b-button>
                        <b-button pill size="md"  variant="warning" @click="actEditImageUsed(row.item)" class="m-1">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.image') }}</span>
                        </b-button>                        
                    </template>
                    <template #cell(contImageUsed)="row" >
                        <b-button size="sm" @click="openModalImageUsed(row.item, row.index, $event.target )" class="m-1">
                            {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
                        </b-button>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPageUsed"
                        :total-rows="totalRowsUsed"
                        :per-page="perPageUsed"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPageUsed"
                            :options="pageOptionsUsed"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                <b-modal
                    :title="$t('container.showRelsContTitle')"
                    v-model="showRelsContModal"
                    header-bg-variant="warning"
                    header-text-variant="dark"
                    body-bg-variant="light"
                    body-text-variant="dark"
                    size="md"
                    hide-footer
                >
                    <b-col class="mt-1 mb-2">
                        <label for="contNo" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{ $t("container.showRelsContMsg") }}</label>
                    </b-col>
                    <div class=" d-flex flex-row justify-content-end">
                        <b-button
                        variant="warning"
                        size="md"
                        class="mx-4"
                        @click="clickShowRelsCont_NO"
                        >
                        {{ $t('container.showRelsCont_NO') }}
                        </b-button>
                        <b-button
                        variant="primary"
                        size="md"
                        @click="clickShowRelsCont_OK"
                        >
                        {{ $t('container.showRelsCont_OK') }}
                        </b-button>
                    </div>
                </b-modal>
                    <!-- Info modal Container Image-->
                <b-modal 
                    id="contModalUsed" 
                    :title="modalTitleUsed" 
                    ok-only 
                    @hide="resetInfoModalUsed"
                >
                    <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModalUsed"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <!-- <button @click="deleteImage(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button> -->
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModalUsed.length }}</span>
                                    </div>
                                    <div v-if="imageUriModalUsed.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModalUsed.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </b-modal>
                <b-modal
                    :title="$t('container.editContNoTitle')"
                    v-model="showEditContNoUsedModal"
                    header-bg-variant="warning"
                    header-text-variant="dark"
                    body-bg-variant="light"
                    body-text-variant="dark"
                    size="sm"
                    hide-footer
                >
                    <b-col class="mt-1 mb-2">
                        <label for="contNo" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{ $t("container.contNo") }}</label>
                        <input v-model="contNo" class="form-control" style="font-size:16px;" type="text" >
                    </b-col>
                    <div class=" d-flex flex-row justify-content-end">
                        <b-button
                        variant="warning"
                        size="md"
                        class="mx-4"
                        @click="clickEditContNo_NO"
                        >
                        {{ $t('container.no') }}
                        </b-button>
                        <b-button
                        variant="primary"
                        size="md"
                        @click="clickEditContNo_OK"
                        >
                        {{ $t('container.save') }}
                        </b-button>
                    </div>
                </b-modal>
                <b-modal
                    :title="$t('container.editImageTitle')"
                    v-model="showEditImageUsedModal"
                    header-bg-variant="warning"
                    header-text-variant="dark"
                    body-bg-variant="light"
                    body-text-variant="dark"
                    size="lg"
                    hide-header-close
                    hide-footer
                >
                    <div class="col-sm-12">
                        <div class="gradient-ow p-1" >
                            <div class="dashboard">
                                <div class="upload-section">
                                    <input
                                    type="file"
                                    ref="fileInputEditImageUsed"
                                    accept="image/*"
                                    multiple
                                    @change="onFileSelectUpdate"
                                    style="display: none"
                                    >
                                    <div class="d-flex flex-row justify-content-center">
                                    <button @click="selectFilesEditImageUsed" class="upload-btn-update" :disabled="images.length >= 6">
                                        {{images.length < 6 ? $t('container.uploadImageFor6') : $t('container.uploadImageDone6') }}
                                    </button>
                                    </div>
                                    <p v-if="images.length < 6" class="upload-6Img-message"> {{$t('approvedTrans.6ImagesReqrMsg')  }}</p>
                                    <p v-if="uploading" class="upload-status">Uploading... {{ uploadProgress }}%</p>
                                </div>
                                <!-- Horizontal Scroll View for Images -->
                                <div class="image-scroll-container">
                                    <div class="image-scroll" ref="scrollContainer">
                                    <div
                                        class="image-item"
                                        v-for="(image, index) in images"
                                        :key="image.id"
                                    >
                                        <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                        <button @click="deleteImageUpdate(image)" class="delete-btn" v-b-popover.hover.top="$t('approvedTrans.deleteEach')" >&times;</button>
                                        <span class="image-counter">{{ index + 1 }} of {{ images.length }}</span>
                                    </div>
                                    <div v-if="images.length === 0" class="no-images">
                                        {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                    </div>
                                
                                    <div class="scroll-controls" v-if="images.length > 1">
                                        <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                        <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                    </div>
                                </div>
                            </div>
                            <span class="f-w-600 text-dark ml-3" style="font-size: 16px;">{{ $t('container.editImageRemark') }} </span>
                        </div>
                    </div>
                    <div class=" d-flex flex-row justify-content-end">
                        <b-button
                        class="mr-5"
                        variant="primary"
                        size="md"
                        @click="clickEditImage_OK"
                        >
                        {{ $t('refillOL.ok') }}
                        </b-button>
                    </div>
                </b-modal>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { storage, agentList, saveWithId, contListAll, deleteItem, uploadImage, deleteImageUrl, updateContNo, updateImageUri, getDocId, mergeObj } from "../../firebase"
import { ref as storageRef, uploadBytesResumable, getDownloadURL} from 'firebase/storage';
import {contSize, contType ,contGrade} from '../../constants/config'
export default {
	data(){
		return{
            showRelsContModal : false,
            showEditContNoUsedModal : false,
            // editContNoUsed: '',
            // editContIdUsed: '',            
            showEditImageUsedModal : false,
            process : "info",
            isHovered: false,
            disabledDates: {
                to: new Date(Date.parse(new Date())-86400000),
            },
            compId : '',
            format: "yyyy-MM-dd",
            agentList : [],
            contId : '',
            contNo : 'Dummy',
            contType: '',
            optionsContType : contType,
            contSize: '',
            optionsContSize : contSize,
            contGrade: '', 
            optionsContGrade : contGrade,
            maxGross: '',
            tare: '',            
            owner: '',
            detDate : '',
            detTS : 0,
            images: [],
            uploading: false,
            uploadProgress: 0,
            items: [],
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true, },  
                { key: 'contId', label: this.$t('container.contId'), sortable: true },  
                { key: 'contImage', label: this.$t('container.contNo'), variant: 'info'},                                 
                { key: 'owner', label: this.$t('release.agent'), sortable: true },  
                { key: 'contType', label: this.$t('release.contType'), sortable: true },
                { key: 'contSize', label: this.$t('release.contSize'), sortable: true},
                { key: 'contGrade', label: this.$t('release.contGrade'), sortable: true},
                { key: 'maxGross', label: this.$t('container.maxGross'), sortable: true},
                { key: 'tare', label: this.$t('container.tare'), sortable: true },
                { key: 'detDate', label: this.$t('require.detDate'), sortable: true, },                  
                { key: 'edit', label: this.$t('container.edit'), variant: 'warning'},
                { key: 'delete', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            itemsUsed: [],
            fieldsUsed: [
                { key: 'index', label: this.$t('seal.item'), sortable: true, },  
                { key: 'contId', label: this.$t('container.contId'), sortable: true },  
                { key: 'contImageUsed', label: this.$t('container.contNo'), variant: 'info'},                               
                { key: 'owner', label: this.$t('release.agent'), sortable: true },  
                { key: 'contType', label: this.$t('release.contType'), sortable: true },
                { key: 'contSize', label: this.$t('release.contSize'), sortable: true},
                { key: 'contGrade', label: this.$t('release.contGrade'), sortable: true},
                { key: 'maxGross', label: this.$t('container.maxGross'), sortable: true},
                { key: 'tare', label: this.$t('container.tare'), sortable: true },
                { key: 'detDate', label: this.$t('require.detDate'), sortable: true, },                  
                // { key: 'contCertGrade', label: this.$t('container.contCertGrade'), sortable: true},
                { key: 'actEdit', label: this.$t('container.actEdit'), variant: 'warning'},

            ],
            totalRowsUsed: 1,
            currentPageUsed: 1,
            perPageUsed: 10,            
            pageOptionsUsed: [5, 10, 15, { value: 100, text: "Show a lot" }],            
            sortDirectionUsed: 'asc',
            filterUsed: null,
            filterOnUsed: [],    
            sortByUsed: 'timestamp',
            sortDescUsed: true,
            imageUriModal: [],
            modalTitle : '',
            imageUriModalUsed: [],
            modalTitleUsed : ''
		}
	},
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
	mounted(){
        this.compId= localStorage.getItem("compId")
        agentList((res)=>{
            this.agentList = res.sort()
            // console.log(`this.agentList =>${JSON.stringify(this.agentList , null ,2)}`)
        })
        this.getActiveContList()
        contListAll(this.compId, false, (res)=>{
            this.itemsUsed = res
            this.totalRowsUsed = res.length
        })
	},
	methods:{
        async getActiveContList(){
            await contListAll(this.compId , true,(res)=>{
                this.items = res
                this.totalRows = res.length
            })
        },        
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },        
        onFilteredUsed(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRowsUsed = filteredItems.length
            this.currentPageUsed = 1
        },
        handleHover(hovered) {
            this.isHovered = hovered
        },
        clickShowRelsCont_NO(){
            this.showRelsContModal = false
        },
        clickShowRelsCont_OK(){
            this.$router.push('/process/release')
        },
        clickCancelProcessAdd(){
            this.process = 'info'
            this.refresh()
        },
        async saveCont(){
                let url6Img = this.images.length == 0 ? [] : this.images
                let d = new Date()
                let yyyy = d.getFullYear().toString()
                let contId = yyyy.substring(2,4)+'CN'+`${Math.floor(Math.random() * (9000000 - 1000000 + 1) + 1000000)}`
                let detDate =  this.detDate == '' ? '' : this.$moment(this.detDate).format("YYYY-MM-DD")
                let detTS =  this.detDate == '' ? 0 : Date.parse(detDate + ' ' + '23:59:59')
                let payload = {
                    compId: this.compId,
                    contId : contId,
                    contNo : this.contNo,
                    contType: this.contType,
                    contSize: this.contSize,
                    maxGross: this.maxGross,
                    tare: this.tare,            
                    contGrade: this.contGrade,
                    // contCertGrade: this.contCertGrade,
                    owner: this.owner,
                    detDate : detDate,
                    detTS : detTS,
                    url6 : url6Img,
                    timestamp: Date.parse(d),
                    active: true
                }
                // console.log ('payload=>'+JSON.stringify(payload , null, 2))
                await saveWithId('Container', contId, payload).then(async()=>{
                    await this.refresh()
                    this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                })
            // })                
        },
        async handleSave(){
            let msg = 'completed'
            if (this.contNo ==='') {
                msg = 'container.addContNo'
            } else if (this.contType ===''){
                msg = 'container.selContType'
            } else if (this.contSize ===''){
                msg = 'container.selContSize'
            // } else if (this.maxGross ===''){
            //     msg = 'container.addMaxGross'
            // } else if (this.tare ===''){
            //     msg = 'container.addTare'
            } else if (this.contGrade ===''){
                msg = 'container.selContGrade'
            // } else if (this.contCertGrade ===''){
            //     msg = 'container.selContCertGrade'
            } else if (this.owner ===''){
                msg = 'container.addOwner'
            // } else if (this.detDate ===''){
            //     msg = 'container.addDetDate'
            // } else if (this.images.length === 0){
            //     msg = 'container.addImage'
            // } else if (this.images.length > 1){
            //     msg = 'container.oneImageOnly'
            }  
            if (msg === 'completed'){
                if (this.images.length > 6) {
                    this.$toasted.show(this.$t('container.max6Images'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});    
                } else {
                    await this.saveCont()
                }                   
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        selectFiles(){
            this.$refs.fileInput.click()
        },
        selectFilesUpdate(){
            this.$refs.fileInputUpdate.click()
        },
        selectFilesEditImageUsed(){
            this.$refs.fileInputEditImageUsed.click()
        },
        async onFileSelect(event) {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            // Limit to 6 images
            const remainingSlots = 6 - this.images.length;
            if (remainingSlots <= 0) {
                this.$toasted.show(this.$t('container.max6Images'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
                return;
            }
            const filesToUpload = Array.from(files).slice(0, remainingSlots);
            this.uploading = true;
            for (const file of filesToUpload) {
                try {
                    const url = await this.uploadImage(file);
                    this.images.push({
                        id: Date.now().toString(), // temporary ID
                        url,
                    // file // keep reference for saving later
                });
                } catch (error) {
                    console.error('Upload failed:', error);
                    this.$toasted.show(this.$t('approvedTrans.failedUpload'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
                    // alert(`${this.$t('approvedTrans.failedUpload')}`);
                    
                }
            }
            // this.fromExstImages = false
            this.uploading = false;
            this.$refs.fileInput.value = ''; // reset input
        },
        async onFileSelectUpdate(event) {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            // Limit to 6 images
            const remainingSlots = 6 - this.images.length;
            if (remainingSlots <= 0) {
                this.$toasted.show(this.$t('container.max6Images'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});     
                return;
            }
            const filesToUpload = Array.from(files).slice(0, remainingSlots);
            this.uploading = true;
            await this.files2Upload( filesToUpload , async(imgs)=>{
                await mergeObj('Container' , this.contId , { url6 : imgs} )
            })
            // this.fromExstImages = false
            this.uploading = false;
            this.$refs.fileInput.value = ''; // reset input
        },
        async files2Upload(filesToUpload ,cb ){
            for (const file of filesToUpload) {
                try {
                    const url = await this.uploadImage(file);
                    this.images.push({
                        id: Date.now().toString(), // temporary ID
                        url,  // file // keep reference for saving later
                });
                } catch (error) {
                    console.error('Upload failed:', error);
                    this.$toasted.show(this.$t('approvedTrans.failedUpload'), {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 10000});
                }
            }
            cb( this.images)
        },

        async uploadImage(file) {
            return new Promise((resolve, reject) => {
                const storageReference = storageRef(storage, `container/${Date.now()}_${file.name}`);
                const uploadTask = uploadBytesResumable(storageReference, file);
                uploadTask.on('state_changed',
                (snapshot) => {
                    this.uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                (error) => {
                    reject(error);
                },
                async () => {
                    try {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                    } catch (error) {
                    reject(error);
                    }
                }
                );
            });
        },

        async deleteImage(image) {
            this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmDeleteImageMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value){
                try {
                    deleteImageUrl('container' , image.url)
                    // Remove from local array
                    this.images = this.images.filter(img => img.id !== image.id);
                } catch (error) {
                    console.error('Error deleting imageAdd:', error);
                    this.$toasted.show(this.$t('approvedTrans.failedDeleteImageMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                }
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete Image: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  
        async deleteImageUpdate(image) {
            this.$bvModal.msgBoxConfirm(this.$t('approvedTrans.confirmDeleteImageMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value){
                try {
                    deleteImageUrl('container' , image.url)
                    // Remove from local array
                    this.images = this.images.filter(img => img.id !== image.id);
                    await mergeObj('Container' , this.contId , { url6 : this.images} )
                } catch (error) {
                    console.error('Error deleting imageAdd:', error);
                    this.$toasted.show(this.$t('approvedTrans.failedDeleteImageMsg'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                }
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete Image: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  

        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "Container", item.contId)
                    for (let i = 0; i < item.url6.length; i++) {
                        await deleteImageUrl('container' , item.url6[i])
                    }
                    await this.getActiveContList()                    
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refresh(){
            await contListAll(this.compId , true,(res)=>{
                this.items = res
                this.totalRows = res.length
                if (res.length == 1) {
                    this.showRelsContModal = true
                }
                this.contNo = 'Dummy'
                this.contType = ''
                this.contSize = ''
                this.maxGross = ''
                this.tare= ''       
                this.contGrade= ''
                this.owner = ''
                this.detDate = ''
                this.detTS = 0
                this.images = []
                this.process = 'info'
            })
        },
        openModalImage(item, index, button) {
            // this.imageUriModal = item.imageUri
            this.imageUriModal = item.url6
            this.modalTitle = item.contNo == 'Dummy' || item.contNo == 'dummy' || item.contNo == '' ? `${this.$t('container.dummyTitle')}` : `${this.$t('container.contNo')}: ${item.contNo}`
            this.$root.$emit('bv::show::modal', "contModal" , button)
        },
        resetInfoModal() {
            this.modalTitle = ''
            this.imageUriModal = []
        },
        openModalImageUsed(item, index, button) {
            // this.imageUriModalUsed = item.imageUri
            this.imageUriModalUsed = item.url6
            this.modalTitleUsed = item.contNo == 'Dummy' || item.contNo == 'dummy' || item.contNo == '' ? `${this.$t('container.dummyTitle')}` : `${this.$t('container.contNo')}: ${item.contNo}`
            this.$root.$emit('bv::show::modal', "contModalUsed" , button)
        },
        resetInfoModalUsed() {
            this.modalTitleUsed = ''
            this.imageUriModalUsed = []
        },
        async handleUpdate(){
            let msg = 'completed'
            if (this.contType ===''){
                msg = 'container.selContType'
            } else if (this.contSize ===''){
                msg = 'container.selContSize'
            } else if (this.maxGross ===''){
                msg = 'container.addMaxGross'
            } else if (this.tare ===''){
                msg = 'container.addTare'
            } else if (this.contGrade ===''){
                msg = 'container.selContGrade'
            } else if (this.detDate ===''){
                msg = 'container.addDetDate'
            }  
            if (msg === 'completed'){
                if (this.images.length > 6) {
                    this.$toasted.show(this.$t('container.max6Images'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});    
                } else {
                    await this.updateCont()
                }   
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async updateCont(){
            let detDate =  this.detDateUpdate == '' ? '' : this.$moment(this.detDateUpdate).format("YYYY-MM-DD")
            let detTS = this.detDateUpdate == '' ? 0 :  Date.parse(detDate + ' ' + '23:59:59')
            let payload = {
                compId: this.compId,
                contId : this.contId,
                contNo : this.contNo,
                contType: this.contType,
                contSize: this.contSize,
                maxGross: this.maxGross,
                tare: this.tare,            
                contGrade: this.contGrade,
                owner: this.owner,
                detDate : detDate,
                detTS : detTS,
                url6 : this.images,
                timestamp: Date.parse(new Date()),
                active: true
            }
            console.log ('payload_updateCont=>'+JSON.stringify(payload , null, 2))
            await saveWithId('Container', this.contId, payload).then(async()=>{
                await this.refresh()
                this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
            })
        },
        async refresh(){
            await contListAll(this.compId ,true ,(res)=>{
                this.items = res
                this.totalRows = res.length
                this.contId = ''
                this.contNo = ''
                this.contType = ''
                this.contSize = ''
                this.maxGross = ''
                this.tare= ''       
                this.contGrade= ''
                // this.contCertGradeUpdate= ''
                this.owner = ''
                this.detDate = ''
                this.detDateTS = 0
                this.images = []
                this.process = 'info'  // close update submenu
            })
        },
        actUpdate(item) {
            this.contId = item.contId
            this.contNo = item.contNo    
            this.owner = item.owner
            this.contType = item.contType
            this.contSize = item.contSize
            this.contGrade = item.contGrade
            this.maxGross = item.maxGross
            this.tare = item.tare
            this.detDate = item.detDate
            this.detTS= item.detTS
            this.images = item.url6
            // this.images_exist = item.url6
            this.process = "update"   // to pop up Update subMenu
            console.log(`url6 => ${JSON.stringify(item , null , 2)}`)
        }, 
        actEditContNoUsed(item) {
            this.contId= item.contId
            this.contNo = item.contNo    
            this.showEditContNoUsedModal = true
        }, 
        async clickEditContNo_NO() {
            this.contId = ''
            this.contNo = ''
            this.showEditContNoUsedModal = false
        },
        async clickEditContNo_OK() {
            let msg = 'completed'
            if (this.contNo ==='') {
                msg = 'container.addContNo'
            }  
            if (msg === 'completed'){
                await updateContNo( "Container", this.contId, this.contNo)
                .then(async()=>{
                    await getDocId("MatchTx" , "contId" , this.contId , async(res)=>{
                        // console.log(`getDocId, MatchTx => ${JSON.stringify(res)}`)
                        if (res.length != 0) {
                            for (let i = 0; i < res.length; i++) {
                            await updateContNo( "MatchTx", res[i], this.contNo)   
                            }
                        } 
                    }) 
                    await getDocId("Release" , "contId" , this.contId , async(res)=>{
                        // console.log(`getDocId, Release => ${JSON.stringify(res)}`)
                        if (res.length != 0) {
                            for (let i = 0; i < res.length; i++) {
                            await updateContNo( "Release", res[i], this.contNo)   
                            }
                        } 
                    })                             
                    await this.refreshContUsedList() 
                })                        
                .catch(error => {
                    this.$toasted.show( `Action-Edit ContNo: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                })
                this.showEditContNoUsedModal = false
                this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});              
            }else{
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        actEditImageUsed(item) {
            this.contId= item.contId
            this.images = item.url6.length == 0 ? [] : item.url6
            this.showEditImageUsedModal = true
            this.process = 'info'
        }, 
        async clickEditImage_OK() {
            if (this.images.length  === 0) {
                this.$toasted.show(this.$t('container.noImg'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 10000});     
                // await mergeObj('Container' , this.contId , { url6 : this.images} )
            } 
            // else {
            //     await mergeObj('Container' , this.contId, { url6 : this.images} ).then(()=>{
            //         this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
            //     })
            // }
            await this.refreshContUsedList() 
            this.showEditImageUsedModal = false
        },
        async refreshContUsedList(){
            await contListAll(this.compId , false, (res)=>{
                this.itemsUsed = res
                this.totalRowsUsed = res.length
                this.contId = ''
                this.contNo = ''
                this.images= []
            })
        },
        scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-ow {
   background: linear-gradient(135deg, orange, white);
 }
 .gradient-yb {
   background: linear-gradient(135deg, yellow, blue);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
 .upload-section {
  margin-bottom: 20px;
  text-align: center;
}
.upload-btn {
  background-color: #f4f007;
  color: rgb(7, 3, 247);
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 20px;
  cursor: pointer;
  width: 40%;
  margin-bottom: 10px;
}
.upload-btn-update {
  background-color: greenyellow;
  color: red(242, 3, 3);
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 20px;
  cursor: pointer;
  width: 40%;
  margin-bottom: 10px;
}
.notRequire-btn {
  background-color: #b8b525;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}
.save-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}

.upload-btn:disabled, .save-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.upload-6Img-message {
  font-size:  16px;
  color: #1a0fe7;
}
.upload-status {
  font-size: 14px;
  color: #666;
} 
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

.display-image {
  width: 100%;
  height: 400px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.delete-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 480px) {
  .image-item {
    flex: 0 0 95%;
  }
 
  .display-image {
    height: 200px;
  }
}
.card{
    width:100%;
    padding:10px;
    box-shadow: 0 0 5px #ffdfdf;
    border-radius: 5px;
    overflow: hidden;
}
.card .top{
    text-align: center;
}
.card p{
    font-weight: bold;
    color: #fe0000;
}
.card button{
    outline: 0;
    border: 0;
    color : #ffff;
    border-radius: 4px;
    font-weight: 40;
    padding: 8px 13px;
    width: 100%;
    background: #fe0000;
}
.card .drag-area{
    height : 100px;
    border-radius: 5px;
    border: 2px dashed #00d4fe;
    background: #f4f3f9;
    color : #fe0000;
    display:flex;
    justify-content: center;
    align-items: center;
    user-select: center;
    -webkit-user-select: none;
    margin-top: 5px;
}
.card .darg-area .visible{
    font-size: 18px
}
.card .select{
    color: #5256ad;
    margin-left: 5px;
    cursor: pointer;
    transition: 0.4s;
}
.card .select :hover{
    opacity: 0.6;
}
.card .container{
    height : auto;
    width: 100%;
    display:flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    max-height: 450px;
    position: relative;
    margin-bottom: 8px;
    padding-top: 15px;
}
.card .container .image{
    width: 480px;
    margin-right: 5px;
    height: 360px;
    position: relative;
    margin-bottom: 8px;
}
.card .container .image img{
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.card .container .image span{
    position:absolute;
    top: -2px;
    right: 9px;
    font-size: 30px;
    cursor: pointer;
}
.card input,
.card .drsg-area .on-drop,
.card .drag-area.dragover .visible{
    display: none;
}
.delete{
    z-index: 999;
    color:#fe0000;
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  /* text-transform: lowercase;
  font-variant: small-caps; */
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.divider {
    height: 5px;
    background-color: #f10909;
    margin:5px
}
</style>
